import { render, staticRenderFns } from "./KeyValue.vue?vue&type=template&id=4dd2ba04&"
import script from "./KeyValue.vue?vue&type=script&lang=js&"
export * from "./KeyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports